<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-layout>
    <v-row justify="center" align="center">
      <v-col cols="12" md="12" class="pt-0">
        <v-card flat>
          <v-card-title>
            App Versionen
            <v-spacer></v-spacer>
            <v-text-field
            v-model="search"
            append-icon="search"
            label="Suche"
            single-line
            hide-details
            ></v-text-field>
          </v-card-title>
        </v-card>
      </v-col>
      <v-col cols="12" md="12">

        <v-data-table
        :headers="headers"
        :items="deviceList"
        :search="search"
        >
          <template v-slot:item.diskUsageCurrent="{ item }">
            <span :style="getHDStyle(item)">{{toMB(item.diskUsageCurrent, 2)}}</span><span> von {{toMB(item.diskUsageMax, 2)}}</span>
          </template>
          <template v-slot:item.company="{ item }">
            <span v-if="item.companyName" @click="openCompanyDialog(item)">{{item.companyName}}</span>
            <span v-if="!item.companyName" class="handpointer" :style="getCompanyStyle(item)"
                  @click="openCompanyDialog(item)">zuweisen</span>
          </template>
          <template v-slot:item.action="{ item }">
            <v-icon
            small
            class="mr-2"
            @click="editItem(item)"
            >
              edit
            </v-icon>
            <v-icon
            small
            @click="deleteItem(item)"
            >
              delete
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <DialogLinkCompany ref="dlgLink" @save="onLinkCompany"></DialogLinkCompany>
  </v-layout>
</template>

<script>
import Vue from 'vue'
import DialogLinkCompany from './../module/dialogs/DialogLinkCompany'
export default {
  name: 'TableDevices',
  props: {
    companyId: String
  },
  components: {DialogLinkCompany},
  methods: {

    openCompanyDialog: function (item) {
      console.log('openCompanyDialog', item)
      this.currentDevice = item
      this.$refs.dlgLink.open({
        title: 'Netzwerk zuweisen',
        description: 'Wählen Sie ein Netzwerk'
      })
    },
    onLinkCompany: function (item) {
      console.log('onLinkCompany', item)
      Vue.prototype.$api.linkDeviceToCompany(this.currentDevice.guid, item, this.reload)
    },
    deleteItem: function (item) {
      Vue.prototype.$api.deleteDevice(item.guid, this.reload)
    },
    editItem: function (item) {
      this.$router.push('/apps/' + item.guid)
    },
    getHDStyle: function (item) {
      var style = ''
      var prz = (100 / item.diskUsageMax) * item.diskUsageCurrent

      if (prz < 80) {
        style = 'color: green'
      } else {
        style = 'color: orange'
      }
      if (prz > 95) {
        style = 'color: red'
      }
      return style
    },
    getCompanyStyle: function (item) {
      var style = ''
      if (!item.company) {
        style = 'color: #aa4444;'
      }
      return style
    },
    toMB: function (bytes, decimals) {
      if (bytes == 0) return '0 Bytes';
      var k = 1024,
      dm = decimals <= 0 ? 0 : decimals || 2,
      sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
      i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    },
    reload: function () {
      Vue.prototype.$api.loadApps(this.onGetData)
    },
    onGetData: function (result) {
      console.log('result', result)
      this.deviceList = result
    }
  },
  data () {
    return {

      currentDevice: null,
      search: null,

      headers: [
        {text: 'Standard', align: 'left', value: 'isDefault'},
        {text: 'Name', align: 'left', value: 'name'},
        {text: 'Beschreibung', value: 'comment'},
        {text: 'Aktion', value: 'action'}
      ],
      deviceList: []
    }
  },
  mounted () {
    var cmp = this
    this.$nextTick(() => {
      cmp.reload()
    })
  }
}
</script>

<style scoped>

</style>
